export default __webpack_public_path__ + "static/media/anthony-cro.b97cfb3e.jpg";